/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TypeAdmissionResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TypeAdmissionListDTO } from "../models";

@Injectable({ providedIn: "root" })
export class TypeAdmissionResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getAllTypeAdmissions(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TypeAdmissionListDTO>>;
    getAllTypeAdmissions(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TypeAdmissionListDTO>>>;
    getAllTypeAdmissions(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TypeAdmissionListDTO>>>;
    getAllTypeAdmissions(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/types-admission`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
